import React, { useEffect, useState } from 'react';
import { HomePage } from './pages/HomePage';
import { SpecialistsPage } from './pages/SpecialistsPage';
import { CompaniesPage } from './pages/CompaniesPage';
import { LanguageProvider } from './i18n/LanguageContext';
function AppContent() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };
    window.addEventListener('popstate', handleLocationChange);
    return () => window.removeEventListener('popstate', handleLocationChange);
  }, []);
  // Simple routing based on URL path, ignoring language prefix
  // Expected paths: /en/, /en/specialists, /en/companies, etc.
  const pathParts = currentPath.split('/');
  // pathParts[0] is "", pathParts[1] is lang, pathParts[2] is page
  const page = pathParts[2];
  if (page === 'specialists') {
    return <SpecialistsPage data-id="element-0" />;
  }
  if (page === 'companies') {
    return <CompaniesPage data-id="element-1" />;
  }
  return <HomePage data-id="element-2" />;
}
export function App() {
  return <LanguageProvider data-id="element-3">
      <AppContent data-id="element-4" />
    </LanguageProvider>;
}